import { SelectChangeEvent } from '@mui/material/Select';
import {
  ActionCreatorWithoutPayload,
  ActionCreatorWithPayload,
} from '@reduxjs/toolkit';

import { ResetConfigModel } from '../../../../../features/shared/models/reset-config.model';
import { useAppDispatch } from '../../../../../store/hooks';

export const useSelectWithCheckboxesOnChange = <TPayloadType>(
  inputName: keyof TPayloadType,
  setFieldValue: (
    field: string,
    value: any,
    shouldValidate?: boolean | undefined
  ) => void,
  dispatchFn: ActionCreatorWithPayload<number[], string>,
  resetConfig?: ResetConfigModel<TPayloadType>[],
  stateResetFn?: ActionCreatorWithoutPayload
): ((event: SelectChangeEvent<number[]>) => void) => {
  const dispatch = useAppDispatch();

  return (event: SelectChangeEvent<number[]>): void => {
    const {
      target: { value },
    } = event;
    setFieldValue(inputName as string, value);
    resetConfig?.forEach(config =>
      setFieldValue(config.fieldName, config.valueToReset)
    );

    if (stateResetFn) {
      dispatch(stateResetFn());
    }

    dispatch(dispatchFn(value as number[]));
  };
};
